import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL

export const getProviderImages = createAsyncThunk("provdier/get-images", async (token, thunkAPI) => {
  try {
    const res = await axios.get(
        `${BACKEND_URL}/provider/get-images`, {
            headers: { Authorization: `Bearer ${token}` },
        });
    // console.log("data", res.data);
    return res.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || "Failed to fetch providers images");
  }
});

export const addProviderImages = createAsyncThunk(
  "provider/add-images",
  async ({ token, data }, { rejectWithValue }) => {
    // console.log("data", data);
    try {
      const response = await axios.post(
        `${BACKEND_URL}/provider/add-images`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteProviderImage = createAsyncThunk(
  "provider/delete-image",
  async ({ token, imageId }, thunkAPI) => {
    try {
      const res = await axios.delete(
        `${BACKEND_URL}/provider/delete-image/${imageId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "Failed to delete provider image"
      );
    }
  }
);

export const updateProviderImage = createAsyncThunk(
  "provider/update-image",
  async ({ token, imageId, data }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BACKEND_URL}/provider/update-image/${imageId}`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to update image");
    }
  }
);

const providerImagesSlice = createSlice({
  name: "providerImages",
    initialState: {
      providerImages: null,
      loading: false,
      error: null,
      message: "",
      
    },
    extraReducers: (builder) => {
      builder
        .addCase(getProviderImages.pending, (state) => {
            state.loading = true;
        })
        .addCase(getProviderImages.fulfilled, (state, action) => {
            state.providerImages = action.payload.providerImages;
            state.loading = false;
        })
        .addCase(getProviderImages.rejected, (state, action) => {
            state.error = action.payload || "Failed to fetch providers image"; 
            state.loading = false;
        })
        .addCase(addProviderImages.fulfilled, (state, action) => {
          state.loading = false;
          state.message = action.payload?.message || "Images uploaded successfully";
        })
        .addCase(deleteProviderImage.pending, (state) => {
          state.loading = true;
        })
        .addCase(deleteProviderImage.fulfilled, (state) => {
          state.loading = false;
        })
        .addCase(deleteProviderImage.rejected, (state, action) => {
          state.error = action.payload || "Failed to delete provider image";
          state.loading = false;
        })
      },
});

export default providerImagesSlice.reducer;